import { IExceptionWord, ExceptionWordDto } from 'types/exceptionWord';
import { createEntityHook } from './createEntityHook';
import { LoginResponse, Login } from '../types/login';
import { LogoutResponse, Logout } from '../types/logout';
import { UserCreate, User, UserUpdate } from '../types/user';
import { Subdivision, Staff, CreateStaff, Tree } from '../types/subdivision';
import { BlockResponse } from '../types/block';
import { RoleResponse } from '../types/role';
import { Search } from '../types/search';
import { SearchTree } from '../types/searchTree';
import { Organization } from '../types/organization';
import { History } from '../types/history';
import { RestorePassword } from '../types/restorePassword';
import { AuthResponse, Auth } from '../types/auth';
import { Thank } from '../types/thank';
import { ValueType, ValueTypeForPost } from '../types/value';
import { IAccessList } from '../Components/EmployeeInfo';
import {
  IOrganizationSettings,
  IStaffSettings,
  ISubdivisionSettings,
} from '../types/configuration';
import { AccessTree } from '../types/accessTree';

// export const useLogin = createEntityHook<LoginResponse, Login>('login');
export const useLogout = createEntityHook<LogoutResponse, Logout>('logout');
export const useUsers = createEntityHook<User, UserCreate>('user');
export const useSecurity = createEntityHook<LoginResponse, Login>('login');
export const useSubdivivsionParrent = createEntityHook<any, Subdivision>(
  'subdivisionParent',
);

export const useSubdivivsion = createEntityHook<Tree, Subdivision>(
  'subdivision',
);

export const useSubdivivsion2 = createEntityHook<Subdivision, Subdivision>(
  'subdivision',
);
export const useBlock = createEntityHook<any, BlockResponse>('block');
export const useRole = createEntityHook<any, RoleResponse>('role');
export const useUpdateUser = createEntityHook<UserUpdate, UserUpdate>(
  'userUpdate',
);

export const useImport = createEntityHook<any, any>('import');
export const useImportData = createEntityHook<any, any>('importData');
export const useStaff = createEntityHook<Staff, CreateStaff>('staff');
export const useSearch = createEntityHook<Search, any>('search');
export const useSearchTree = createEntityHook<SearchTree, any>('searchTree');
export const useOrganization = createEntityHook<Organization, any>(
  'organization',
);
export const useHistory = createEntityHook<History, any>('history');
export const useChangeKarmaUser = createEntityHook<Staff, Subdivision>(
  'isKarmaUserUpdate',
);
export const useSendEmail = createEntityHook<any, any>('sendEmail');
export const useRestorePassword = createEntityHook<RestorePassword, any>(
  'restorePassword',
);
export const useAuth = createEntityHook<AuthResponse, Auth>('auth');
export const useThanks = createEntityHook<Thank, any>('thank');
export const useValue = createEntityHook<any, ValueType | ValueTypeForPost>(
  'value',
);
export const useDownload = createEntityHook<any, any>('download');
export const useLimit = createEntityHook<any, any>('limit');
export const useMaxLimit = createEntityHook<any, any>('maxLimit');
export const useReceived = createEntityHook<Thank[], any>('received');
export const useSent = createEntityHook<Thank[], any>('sent');

export const useAnalytics = createEntityHook<any, { data: IAccessList }>(
  'analytics',
);
export const useAnalyticsTree = createEntityHook<AccessTree, any>('analytics');
export const useStatus = createEntityHook<any, any>('status');
export const useConfiguration = createEntityHook<
  ISubdivisionSettings | IOrganizationSettings | IStaffSettings,
  ISubdivisionSettings | IOrganizationSettings | IStaffSettings
>('configuration');

export const useExceptionWords = createEntityHook<
  IExceptionWord,
  ExceptionWordDto
>('word', {
  createEntity: 'Слово успешно добавлено',
  updateEntity: 'Слово успешно изменено',
  deleteEntity: 'Слово успешно удалено',
});
